<template>
  <section id="all-results-listing" class="all-cases-view">
    <div class="navbarComponent">
      <div class="container-default">
        <div class="listings-navbar">
          <el-row>
            <el-col :lg="7">
              <ul class="d-flex flex-wrap list-items-group-15">
                <li v-if="hasPermission('cases', 'report_upload_new')">
                  <el-button
                    class="btn button-with-icon"
                    @click="goToUploadFile()"
                  >
                    <span class="mr-8">
                      <img
                        src="@/assets/images/icons/upload-file.svg"
                        alt="icon"
                        class="inactive"
                      />
                      <img
                        src="@/assets/images/icons/upload-file-white.svg"
                        alt="icon"
                        class="active"
                      />
                    </span>
                    <span>UPLOAD FILES</span>
                  </el-button>
                </li>
                <li>
                  <el-button
                    class="btn button-with-icon"
                    @click="onReportsExport"
                  >
                    <span class="mr-8">
                      <img
                        src="@/assets/images/icons/export-icon-with-bg-blue.svg"
                        alt="icon"
                        class="inactive"
                      />
                      <img
                        src="@/assets/images/icons/export-icon-white.svg"
                        alt="icon"
                        class="active"
                      />
                    </span>
                    <span>Export</span>
                  </el-button>
                </li>
              </ul>
            </el-col>
            <el-col :lg="17">
              <ul
                class="d-flex flex-wrap justify-content-end list-items-group-15"
              >
                <li>
                  <div
                    class="form-element search-with-filter-input"
                    v-if="
                      getAuthenticatedUser.user_type == 'LAB_TECHNOLOGIST' &&
                      getAuthenticatedUser.allowed_case_types
                    "
                  >
                    <el-select
                      v-model="caseType"
                      placeholder="Select"
                      filterable
                      clearable
                      default-first-option
                      :reserve-keyword="false"
                      @change="handleCurrentChange(1)"
                    >
                      <el-option
                        v-for="caseType in getUserBasedCaseTypes(caseTypes)"
                        :key="caseType"
                        :label="caseType.label"
                        :value="caseType.value"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                  <div class="form-element search-with-filter-input" v-else>
                    <el-select
                      v-model="caseType"
                      placeholder="Select"
                      filterable
                      clearable
                      default-first-option
                      :reserve-keyword="false"
                      @change="handleCurrentChange(1)"
                    >
                      <el-option
                        v-for="caseType in getLabBasedCaseTypes(caseTypes)"
                        :key="caseType"
                        :label="caseType.label"
                        :value="caseType.value"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="container-default" style="padding-top: 0">
      <div class="primary-content-view-new" v-loading="loading">
        <div class="listings listings__table listings__all-cases">
          <el-table
            :data="getAllResultFiles.data"
            height="calc(100vh - 200px)"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
            @sort-change="onChangeSort"
          >
            <el-table-column
              fixed="left"
              prop="name"
              label="FILE NAME"
              width="400"
              sortable="custom"
            >
              <template #default="scope">
                <div class="name-accession">
                  <div class="d-flex">
                    <span class="order-files ml-5">
                      <img
                        src="@/assets/images/orders-table-file.svg"
                        alt="icon"
                      />
                    </span>
                    <span
                      id="accession-id"
                      class="table_cell-ellipsis cursor ml-5"
                      @click="viewReports(scope.row)"
                    >
                      {{ scope.row.name }}
                    </span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="CASE TYPE"
              prop="case_type"
              sortable="custom"
              fixed="left"
            >
              <template #default="scope">
                <div class="case-type">
                  <span class="case-data-type">
                    {{ caseTypeMap[scope.row.case_type] }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="STATUS" prop="status" sortable="custom">
              <template v-slot="scope">
                <div class="column-status">
                  <el-tag :type="getStatusType(scope.row.status)">{{
                    scope.row.status
                  }}</el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="PROGRESS" prop="status" sortable="custom">
              <template #default="scope">
                <div class="progress-btn">
                  <el-button
                    type="text"
                    class="process-btn"
                    v-if="showProcessReport(scope.row)"
                    @click="processReport(scope.row)"
                    >Process File</el-button
                  >
                  <div
                    v-if="
                      scope.row.case_type == 'TOXICOLOGY' &&
                      hasPermission('cases', 'report_upload_new')
                    "
                  >
                    <el-button
                      type="text"
                      class="generate-btn"
                      @click="generateReportToxicology(scope.row)"
                      v-if="
                        scope.row.status == 'TO-START' &&
                        scope.row.file_processed
                      "
                      >Generate Report</el-button
                    >
                  </div>
                  <div v-else>
                    <el-button
                      type="text"
                      class="generate-btn"
                      @click="generateReport(scope.row)"
                      v-if="
                        scope.row.status == 'TO-START' &&
                        scope.row.file_processed &&
                        hasPermission('cases', 'report_upload_new')
                      "
                      >Generate Report</el-button
                    >
                  </div>

                  <el-button
                    type="text"
                    class="view-progress-btn"
                    v-if="
                      scope.row.status !== 'TO-START' &&
                      scope.row.file_processed
                    "
                    @click="viewReports(scope.row)"
                    >View Progress</el-button
                  >
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="uploaded_by"
              label="UPLOADED BY"
              sortable="custom"
              width="220"
            >
              <template #default="scope">
                <span
                  >{{ scope.row.uploaded_by.first_name }}
                  {{ scope.row.uploaded_by.last_name }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              label="CREATED ON"
              prop="created_at"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.created_at" class="d-flex">
                  <div class="date pr-10">
                    {{
                      momentWithTimezone(
                        scope.row.created_at,
                        "MM-DD-yyyy hh:mm A"
                      )
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="updated_at"
              label="UPDATED ON"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.updated_at" class="d-flex">
                  <div class="date pr-10">
                    {{
                      momentWithTimezone(
                        scope.row.updated_at,
                        "MM-DD-yyyy hh:mm A"
                      )
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="processed_time"
              label="Generation Time"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.processed_time" class="d-flex">
                  <div class="date pr-10">
                    {{scope.row.processed_time ? scope.row.processed_time : "--"}}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="action"
              label="Actions"
              fixed="right"
              width="100"
            >
              <template #default="scope">
                <ul class="listings__action-buttons">
                  <li>
                    <el-button
                      class="view-button"
                      @click="downloadFile(scope.row)"
                      title="Download Result File"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/download-new-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/download-new.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li v-if="scope.row.status != 'ARCHIVED'">
                    <el-button
                      class="view-button"
                      @click="onDeleteFile(scope.row)"
                      title="Delete Result File"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/delete-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/delete-deactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="listings listings__pagination">
          <el-pagination
            v-model:currentPage="page"
            v-model:page-size="pageSize"
            :page-sizes="[25, 50, 75, 100]"
            layout="prev, pager, next, jumper, sizes, total"
            :total="getAllResultFiles.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <ExportResultFiles
      v-if="exportReportsDialogVisisble"
      v-on:close="exportReportsDialogVisisble = false"
      :search_case_status="selectedStatuses"
      :selected_case_type="caseType"
    >
    </ExportResultFiles>

    <div class="default-modal">
      <el-dialog
        v-model="generateReportDialog"
        width="65%"
        :before-close="handleClose"
        title="CONFIRMATION TESTS"
        v-loading="loading"
      >
        <div class="export-dialog-header">
          <div class="export-header-part">
            <h3>GENERATE REPORT</h3>
          </div>

          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="generateReportDialog = false"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
          /></el-button>
        </div>
        <div class="dialog-body" v-loading="dataLoading">
          <div
            v-if="all_accession_numbers && all_accession_numbers.length"
            class="export-popup-body"
          >
            <div class="generate-qc-radio">
              <el-radio-group v-model="radio" @change="clearFields()">
                <el-radio label="1">ALL TESTS</el-radio>
                <el-radio label="2">SPECIFIC ACCESSION ID's</el-radio>
              </el-radio-group>
            </div>
            <div class="select-fields">
              <ul class="select-fields-list" v-if="radio == 1">
                <li class="search-checkbox">
                  <el-checkbox
                    v-model="is_all"
                    label="All"
                    value="is_all"
                  ></el-checkbox>
                </li>
              </ul>
              <ul class="select-fields-list" v-if="radio == 2">
                <li
                  class="search-checkbox"
                  v-for="(item, index) in all_accession_numbers"
                  :key="index"
                >
                  <el-checkbox-group v-model="selectedAccessionIds">
                    <el-checkbox :key="index" :label="item" :value="item">
                    </el-checkbox>
                  </el-checkbox-group>
                </li>
              </ul>
            </div>
          </div>
          <div v-else class="no-data">No Data</div>
        </div>
        <div
          class="dialog-footer w-95"
          v-if="all_accession_numbers && all_accession_numbers.length"
        >
          <el-button
            class="blue-save-button"
            :disabled="isTestsSelected"
            @click="
              submitToxicologyReport(this.getSampleNames.data[0].result_file_id)
            "
            v-loading="generateToxicologyReportLoading"
            >Submit</el-button
          >
        </div>
      </el-dialog>
    </div>
  </section>
</template>
<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
const ExportResultFiles = defineAsyncComponent(() =>
  import("@/components/results/ExportResultFiles")
);
import { ref } from "vue";
import FilterHelper from "@/mixins/FilterHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
export default {
  name: "",
  components: { ExportResultFiles },
  mixins: [FilterHelper, caseDataHelper, UserPermissionsHelper],
  props: {
    selectedStatuses: {
      default: [],
    },
  },

  data() {
    return {
      scrollPosition: null,
      generateReportDialog: false,
      exportReportsDialogVisisble: false,
      page: 1,
      pageSize: 25,
      loading: false,
      dataLoading: false,
      no_accessionId: false,
      orderBy: "",
      orderType: "",
      caseType: "",
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      caseTypes: caseConstants.CASE_TYPES_DATA,
      selectedResultFiles: "",
      selectedAccessionIds: [],
      checkAll: false,
      isIndeterminate: false,
      all_accession_numbers: [],
      is_all: false,
      radio: ref("1"),
    };
  },
  computed: {
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "default";
        } else if (status == "COMPLETED") {
          return "success";
        } else if (status == "PROCESSING") {
          return "warning";
        } else if (status == "ARCHIVED") {
          return "danger";
        } else {
          return "";
        }
      };
    },
    ...mapGetters("resultFiles", [
      "getAllResultFiles",
      "getSampleNames",
      "getToxicologyAccessionIds",
    ]),
    ...mapGetters("respiratoryFileUpload", [
      "getGenerateReportStatus",
      "getFileDeleteStatus",
      "getFileDownloadUrl",
      "getProcessReportStatus",
      "getGenerateResultsStauts",
    ]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    isTestsSelected() {
      if (
        this.is_all ||
        (this.selectedAccessionIds && this.selectedAccessionIds.length)
      ) {
        return false;
      }
      return true;
    },
  },
  mounted() {
    this.setQueryParamsData();
    this.fetchResultFiles();
  },
  methods: {
    async onReportsExport() {
      this.loading = true;
      this.exportReportsDialogVisisble = true;
      this.loading = false;
    },
    async updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    showProcessReport(data) {
      if (data.case_type == "TOXICOLOGY" && !data.file_processed) {
        return true;
      }
      return false;
    },
    setQueryParamsData() {
      this.page = this.$route.query.selectedResultFilesPage
        ? parseInt(this.$route.query.selectedResultFilesPage)
        : 1;
      this.pageSize = this.$route.query.selectedResultFilesPageSize
        ? parseInt(this.$route.query.selectedResultFilesPageSize)
        : 25;
      if (this.$route.query.selectedResultFilesCase) {
        this.caseType = this.$route.query.selectedResultFilesCase;
      }
      if (this.$route.query.selectedResultFilesOrderBy) {
        this.orderBy = this.$route.query.selectedResultFilesOrderBy;
      }
      if (this.$route.query.selectedResultFilesOrderType) {
        this.orderType = this.$route.query.selectedResultFilesOrderType;
      }
    },

    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "";
        this.orderType = "";
      }
      this.fetchResultFiles();
    },

    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchResultFiles();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchResultFiles();
    },

    async downloadFile(doc) {
      await this.$store.dispatch("respiratoryFileUpload/fetchFileDownloadUrl", {
        path: doc.path,
      });

      let url = this.getFileDownloadUrl.download_url;
      window.open(url, "_blank");
    },

    onDeleteFile(doc) {
      let params = {
        id: doc._id,
      };
      this.$prompt("Are you sure to delete the Result file ?", "Confirm", {
        confirmButtonText: "Submit",
        cancelButtonText: "Cancel",
        inputPlaceholder: "Reason for deleting",
        inputPattern: /^.{3,}/,
        inputErrorMessage: "Reason must be 3 charcters",
        inputValidator: (value) => {
          return !value || value.trim().length == 0
            ? "Reason is required"
            : true;
        },
      }).then(({ value }) => {
        params.data_delete_reason = value;
        this.deleteFile(params);
      });
    },

    async deleteFile(params) {
      try {
        await this.$store.dispatch(
          "respiratoryFileUpload/deleteSingleFile",
          params
        );

        if (this.getFileDeleteStatus) {
          successNotification("Result file deleted successfully");
          this.page = 1;
          this.fetchResultFiles();
        }
      } catch (err) {
        console.log(err);
        errorNotification("Error at deleting result file");
      }
    },
    // Fetch Accession ID's - Toxicology
    async generateReportToxicology(sampleData) {
      try {
        this.radio = ref("1");
        this.is_all = false;
        this.selectedAccessionIds = [];
        this.generateReportDialog = true;
        this.dataLoading = true;
        let params = {
          result_file_id: sampleData._id,
          get_all: true,
        };
        await this.$store.dispatch("resultFiles/fetchSampleNames", {
          get_all: true,
          result_file_id: sampleData._id,
        });
        if (this.getSampleNames && this.getSampleNames.data) {
          this.all_accession_numbers = [
            ...new Set(
              this.getSampleNames.data.map((item) => item.sample_name)
            ),
          ];
        }
        this.isTestsSelected = false;
        this.dataLoading = false;
      } catch (error) {
        console.error("Error fetching sample names:", error);
      }
    },
    // Submit Report - Generate Report - Toxicology
    async submitToxicologyReport(getId) {
      this.loading = true;
      let params = {
        id: getId,
      };
      if (this.is_all) {
        params.specific_accession_numbers = this.all_accession_numbers || [];
      } else {
        params.specific_accession_numbers = this.selectedAccessionIds || [];
      }
      await this.$store.dispatch(
        "respiratoryFileUpload/generateReportsFromFileUploads",
        params
      );
      this.loading = false;
      if (
        this.getGenerateReportStatus &&
        this.getGenerateReportStatus.success
      ) {
        this.$notify({
          title: "Success",
          message: this.getGenerateReportStatus.message,
          type: "success",
        });
        this.generateReportDialog = false;
        await this.fetchResultFiles();
      } else if (this.getGenerateReportStatus && !this.getGenerateReportStatus.success) {
        errorNotification(this.getGenerateReportStatus.message || "Error generating report");
      }
    },
    // Clear values on radio button change
    clearFields() {
      (this.is_all = false), (this.selectedAccessionIds = []);
    },

    async generateReport(sampleData) {
      let params = {
        id: sampleData._id,
      };
      this.result_file_id = sampleData._id;
      this.loading = true;
      await this.$store.dispatch(
        "respiratoryFileUpload/generateReportsFromFileUploads",
        params
      );
      this.loading = false;
      if (
        this.getGenerateReportStatus &&
        this.getGenerateReportStatus.success
      ) {
        this.$notify({
          title: "Success",
          message: this.getGenerateReportStatus.message,
          type: "success",
        });
        await this.fetchResultFiles();
      } else if (this.getGenerateReportStatus && !this.getGenerateReportStatus.success) {
        errorNotification(this.getGenerateReportStatus.message || "Error generating report");
      }
    },
    async processReport(report) {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "respiratoryFileUpload/processReport",
          report._id
        );
        if (this.getProcessReportStatus) {
          successNotification("File Processed Successfully");
          await this.fetchResultFiles();
        } else {
          errorNotification("Error in processing Report");
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;

        errorNotification("Error in processing Report");
      }
    },
    async viewReports(resultFile) {
      let params = {};
      if (this.filterCaseType) {
        params.case_type = this.filterCaseType;
      }
      if (resultFile.file_processed || resultFile.case_type != "TOXICOLOGY") {
        this.$router.push({
          name: "viewprogress",
          params: {
            result_file_id: resultFile._id,
          },
          query: {
            ...this.$route.query,
            redirectRoute: this.$route.name,
            selectedResultDetailsPage: undefined,
            selectedResultDetailsPageSize: undefined,
          },
        });
      }
    },
    async generateResultsSummary(sampleData) {
      let params = {
        id: sampleData._id,
      };
      this.result_file_id = sampleData._id;
      this.loading = true;
      await this.$store.dispatch(
        "respiratoryFileUpload/generateResultsForReportsSummary",
        params
      );
      this.loading = false;
      if (
        this.getGenerateResultsStauts &&
        this.getGenerateResultsStauts.success
      ) {
        this.$notify({
          title: "Success",
          message: this.getGenerateResultsStauts.message,
          type: "success",
        });
        await this.fetchResultFiles();
      }
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedResultFilesPage: params.page,
        selectedResultFilesCase: params.case_type,
        selectedResultFilesPageSize: params.limit,
        selectedResultFilesOrderBy: params.order_by,
        selectedResultFilesOrderType: params.order_type,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    prepareParams() {
      const params = {
        page: this.page,
        limit: this.pageSize,
      };
      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }
      if (this.caseType) {
        params.case_type = this.caseType;
      }
      params.status = this.selectedStatuses;
      return params;
    },
    async fetchResultFiles() {
      try {
        this.loading = true;
        let params = this.prepareParams();
        await this.$store.dispatch("resultFiles/fetchAllResultFiles", params);
        this.updateQueryParams(params);
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    goToUploadFile() {
      this.$router.push({ name: "allResultsFileUpload" });
    },
  },
};
</script>

<style lang="scss">
#all-results-listing {
  .order-files {
    img {
      position: relative;
      top: 3px;
      right: 4px;
    }
  }
  .stickyNavbar {
    padding-bottom: 5px !important;
    .container-default {
      padding-top: 0;
    }
  }
  .progress-btn {
    .el-button {
      min-height: 0;
      padding: 0;
      color: #5162fd;
      font-size: 14px;
      font-weight: 500;
      &.generate-btn {
        color: green;
      }
      &.process-btn {
        color: #f28b0c;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  label {
    width: 15%;
  }
}
.dialog-body {
  min-height: 100px;
}
.no-data {
  text-align: center;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #000;
}
.export-popup-body {
  margin-top: 20px;
  padding: 15px;
  max-height: 500px;
  overflow-y: scroll;
}
</style>
